import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import Page from '../types/Page';
const recurse = (current: Page, breadcrumbs: JSX.Element[] | undefined): JSX.Element[] | undefined => {
    let collector: JSX.Element[];
    let isCurrent = false;
    if (!breadcrumbs) {
        collector = [];
        isCurrent = true;
    } else {
        collector = [...breadcrumbs];
    }
    for (let key in current) {
        if (key === 'parent'){
            const parent = current[key];
            let el: JSX.Element;
            if (isCurrent) {
                el = <li key={current.id} className="breadcrumb-item active" aria-current="page">{current.title}</li>
            } else {
                el = <li key={current.id} className="breadcrumb-item"><Link key={current.id} to={`/page/${current.slug}`}>{current.title}</Link></li>;
            }
            collector?.unshift(el);
            if (parent) {
                return recurse(parent, collector);
            }
        }
    }
    collector.unshift(<li key="home" className="breadcrumb-item"><Link to={`/`}>Home</Link></li>)
    return collector
}
const Breadcrumbs = ({ current }: { current: Page }) => {
  return (
    <>
      <Breadcrumb>
        {recurse(current, undefined)}
      </Breadcrumb>
    </>
  );
};

export default Breadcrumbs; 